var Tree = require('../hierarchy/frResultTree'),
    SearchResult = require('./SearchResult'),
    SearchPageResult = require('./SearchPageResult');


var SearchTree = function( root ) {

    Tree.apply( this, arguments );

};


SearchTree.prototype = Object.create( Tree.prototype );
SearchTree.prototype.constructor = SearchTree;



_.extend( SearchTree.prototype, {

    PAGE_NODE_LEVEL: 2,

    getParentOfHitModel: function( hit ) {

        return this.getRoot()
            .getChild( hit.get('searchModelId') )
            .getChild( hit.get('pageId') );

    },


    /* just break the link -- child currently in bbone models, ugh ... just break the link */
    removeSearch: function( searchId ) {

      // this.getRoot().removeChild( searchId ); -- doesn't work

        delete this.getRoot().getChildren()[searchId];

    },

    addHitFromSearch: function( hit, parentNoteOfHit, currentPageNumber ) {

        var root = this.getRoot();

        var search = hit.get('search'),
            searchId = search.cid;

        if ( !root.getChild(searchId) ) {

            root.addChild( searchId, new SearchResult({
                search: search,
                note: parentNoteOfHit,
                parent: root
            }));

        }

        var searchPageResult = root.getChild( searchId ),
            pageId = hit.get('pageId');

        if ( !searchPageResult.hasChild( pageId ) ) {

            searchPageResult.addChild( pageId, new SearchPageResult({
                pageId: pageId,
                pageNumber: hit.get('pageNumber'),
                parentId: searchId,
                parent: searchPageResult,
                isCurrentPage: currentPageNumber === hit.get('pageNumber')
            }));

        }

        searchPageResult.getChild( pageId ).addChild( hit.id, hit );

    }


});


module.exports = SearchTree;




/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/models/searchResults/searchHierarchy/SearchTree.js
 ** module id = 671
 ** module chunks = 0
 **/